import {StyleSheet} from "react-native";
import {styleVars} from "../../app-style-vars";

export const styles = StyleSheet.create({
  popupContainer: {
    position: 'absolute',
    bottom: styleVars.rem(1),
    left: 0,
    width: '100%',
    minHeight: styleVars.rem(3),
    zIndex: 2,
  },
  popupWrapper: {
    margin: styleVars.rem(.5),
    borderWidth: 1,
    borderColor: styleVars.boschLightGray,
    backgroundColor: '#fff',
  },
  closeButtonContainer: {
    position:'absolute',
    right:styleVars.rem(.5),
    top: styleVars.rem(.5),
    minWidth: styleVars.rem(1.5),
    backgroundColor:'#fff',
    zIndex: 2
  },
  messageContainer: {
    padding: styleVars.rem(.5),
    paddingRight: styleVars.rem(2.5),
    backgroundColor:'#fff'
  },
  messageIconImage: {
    width: styleVars.rem(1.5),
    height: styleVars.rem(1.5),
    bottom: styleVars.rem(-0.25)
  },
  messageText: {
    fontSize:styleVars.rem(.875),
    color:'#000',
    textAlign: 'justify',
    lineHeight: styleVars.rem(1.5)
  }
})